import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { MenuServices } from '../../../../menu/services';

/**
 * Generated class for the ComboPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-partial-section-name',
    templateUrl: 'combo-partial-section-name.html',
})
export class ComboPartialSectionNamePage {

    @Input() section_index;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        public translate: TranslateService,
        public menuServices: MenuServices) {
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-dish-select/combo-partial-section-name/combo-partial-section-name.ts